import { fabric } from "fabric"
import DrawableMixin from "@/signomatic/app/objects/drawable_mixin"

const PathObject = DrawableMixin(fabric.Path)

export default PathObject
